import store from '@/store';
const WorkflowModel = () => import(/* webpackChunkName: "workflow" */'@/components/pages/workflow/WorkflowModel');
const WorkflowDeployment = () => import(/* webpackChunkName: "workflow" */'@/components/pages/workflow/WorkflowDeployment');
const WorkflowDefine = () => import(/* webpackChunkName: "workflow" */'@/components/pages/workflow/WorkflowDefine');
const WorkflowManage = () => import(/* webpackChunkName: "workflow" */'@/components/pages/workflow/WorkflowManage');
const OperateManagePage = () => import(/* webpackChunkName: "workflow" */'@/components/pages/workflow/OperateManagePage');
const TopMenu = () => import(/* webpackChunkName: "base" */'@/components/common/TopMenu');
const routerMapping = {
  'WF_MNG_MODELS_QUERY': '/system/flow-center/flow-model',
  'WF_MNG_DEPLOY_QUERY': '/system/flow-center/flow-deploy',
  'WF_MNG_DEFINITION_QUERY': '/system/flow-center/flow-define',
  'WF_MNG_QUERY': '/system/flow-center/flow-manage'
}
export default [
  {
    path: 'flow-center',
    name: 'serviceConfiguration',
    redirect: () => {
      let index = store.state.tab.workPages.findIndex(p => p.secondParent === '/system/flow-center');
      if (index > -1) {
        return store.state.tab.workPages[index].routePath;
      } else {
        const roleIds = store.state.base.roleIds;
        let router = '/system/flow-center/flow-model';
        for (var item in routerMapping) {
          if (roleIds.includes(item)) {
            router = routerMapping[item];
            break;
          }
        }
        return router;
      }
    },
    component: TopMenu,
    meta: {
      title: '流程中心',
      icon: 'service-configuration',
      roles: [
        'WF_MNG_MODELS_QUERY',
        'WF_MNG_DEPLOY_QUERY',
        'WF_MNG_DEFINITION_QUERY',
        'WF_MNG_QUERY'
      ]
    },
    children: [
      {
        path: 'flow-model',
        name: 'flowModel',
        component: WorkflowModel,
        meta: {
          roles: ['WF_MNG_MODELS_QUERY'],
          title: '流程模型',
          componentName: 'WorkflowModel',
          breadcrumb: [
            {
              name: '流程模型',
              path: '/system/flow-center/flow-model'
            }
          ]
        }
      },
      {
        path: 'flow-deploy',
        name: 'flowDeploy',
        component: WorkflowDeployment,
        meta: {
          roles: ['WF_MNG_DEPLOY_QUERY'],
          title: '流程部署',
          componentName: 'WorkflowDeployment',
          breadcrumb: [
            {
              name: '流程部署',
              path: '/system/flow-center/flow-deploy'
            }
          ]
        }
      },
      {
        path: 'flow-define',
        name: 'flowDefine',
        component: WorkflowDefine,
        meta: {
          roles: ['WF_MNG_DEFINITION_QUERY'],
          title: '流程定义',
          componentName: 'WorkflowDefine',
          breadcrumb: [
            {
              name: '流程定义',
              path: '/system/flow-center/flow-define'
            }
          ]
        }
      },
      {
        path: 'flow-manage',
        name: 'flowManage',
        component: WorkflowManage,
        meta: {
          roles: ['WF_MNG_QUERY'],
          title: '流程管理',
          componentName: 'WorkflowManage',
          breadcrumb: [
            {
              name: '流程管理',
              path: '/system/flow-center/flow-manage'
            }
          ]
        }
      },
      {
        path: 'edit-flow/:id',
        props: true,
        name: 'editFlow',
        meta: {
          roles: ['WF_MNG_UPDATE'],
          title: '编辑流程',
          hidden: true,
          activeMenu: '/system/flow-center/flow-manage',
          componentName: 'OperateManagePage',
          breadcrumb: [
            {
              name: '流程管理',
              path: '/system/flow-center/edit-flow/:id'
            }
          ]
        },
        component: OperateManagePage
      },
      {
        path: 'create-flow',
        name: 'createFlow',
        meta: {
          roles: ['WF_MNG_ADD'],
          title: '新建流程',
          hidden: true,
          activeMenu: '/system/flow-center/flow-manage',
          componentName: 'OperateManagePage',
          breadcrumb: [
            {
              name: '流程管理',
              path: '/system/flow-center/create-flow'
            }
          ]
        },
        component: OperateManagePage
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/flow.js